<template>
  <div class="back-arrow-area">
    <div class="back-arrow-button" @click="click">
      <BackArrowSVG class="back-arrow-icon" />
    </div>
  </div>
</template>

<script>
import BackArrowSVG from "@/assets/globals/arrow_back.svg";

export default {
  name: "ManagementPageBackArrow",
  components: { BackArrowSVG },
  methods: {
    /**
     * Sends an event to the parent warning about the click event.
     */
    click() {
      this.$emit("buttonClick");
    }
  }
};
</script>

<style scoped>
.back-arrow-area {
  height: 90px;
  display: flex;
  align-items: center;
}
.back-arrow-button {
  width: 28px;
  height: 28px;
  padding: 6px;
  margin-left: 18px;
  margin-top: 10px;
  border-radius: 100%;
  transition: 0.3s all;
  cursor: pointer;
}
.back-arrow-button:hover {
  background-color: #eaeaea;
}
.back-arrow-icon {
  width: 16px;
  height: 16px;
  fill: var(--primary-highlight);
}
</style>



// WEBPACK FOOTER //
// src/components/Management/ManagementPageBackArrow.vue